// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader-module--loader--2d_5s","one":"Loader-module--one--1TPWD","two":"Loader-module--two--32vDY","three":"Loader-module--three--2q_aN"};